/**
 * Sistema de privilegios por rol — fuente única para rutas y navegación.
 */

export const ROLES = {
  ADMIN: "admin",
  RH: "rh",
  SCHEDULER: "scheduler",
  SUPERVISOR: "supervisor",
  CALIDAD: "calidad",
  TECHNICIAN: "technician",
};

/** Grupos de acceso reutilizables (alineados con App.js y AppNav) */
export const ACCESS = {
  /** Dashboard / resumen */
  DASHBOARD: ["admin", "rh", "scheduler", "supervisor", "calidad"],
  /** Módulos de administración operativa */
  OPERATIONS: ["admin", "rh", "scheduler", "supervisor", "calidad"],
  /** Inventario */
  INVENTARIO: ["admin", "rh", "supervisor", "calidad"],
  /** Recursos Humanos (técnicos / expedientes) */
  RH_MODULE: ["admin", "rh"],
  /** Módulo de evaluación mensual de técnicos */
  EVALUACION: ["admin", "rh", "calidad", "scheduler"],
  /** Solo administrador */
  ADMIN_ONLY: ["admin"],
  /** Calendario */
  CALENDARIO: ["admin", "rh", "scheduler", "supervisor", "calidad"],
  /** Reportes */
  REPORTES: ["admin", "rh", "scheduler", "supervisor", "calidad"],
  /** Configuración */
  CONFIGURACION: ["admin"],
  /** Agenda personal del técnico en campo */
  AGENDA: ["technician"],
};

export const normalizeRole = (role) =>
  typeof role === "string" ? role.trim().toLowerCase() : "";

export const hasRoleAccess = (userRole, allowedRoles) => {
  const role = normalizeRole(userRole);
  if (!role || !Array.isArray(allowedRoles)) return false;
  return allowedRoles.some((allowed) => normalizeRole(allowed) === role);
};
